<template>
  <v-data-table
    :loading="loading"
    class="data-table patients-list_table"
    :headers="headersTranslated"
    :items="items"
    :search="search"
  >
    <template v-slot:item.checkbox="{ item }">
      <v-simple-checkbox v-model="item.checked"></v-simple-checkbox>
    </template>
    <template v-slot:header.data-table-select="{ on, props }">
      <v-simple-checkbox v-bind="props" v-on="on"></v-simple-checkbox>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-icon small class="mr-2" v-on="on"> mdi-dots-horizontal </v-icon>
        </template>
        <v-list>
          <v-list-item v-for="action in actions" :key="action.text" @click="action.callback(item)">
            <v-list-item-title>{{ action.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: "PatientsListTable",
  props: {
    headers: Array,
    items: Array,
    search: String,
    loading: Boolean,
    actions: Array,
  },
  computed: {
    headersTranslated() {
      return this.headers.map((item) => ({
        ...item,
        text: item.text ? this.$t(`patients.table.headers.${item.text}`) : "",
      }));
    },
  },
};
</script>
